<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-leaver-member-class-school"
            @hidden="resetModal">
            <div class="container wrap-form-leaver-class-school">
                <h4>
                    <strong>Rời lớp học</strong>
                </h4>
                <p class="font-size-20 text-center primary-color-txt font-sanpro-light">
                    Bạn có chắc chắn bạn muốn rời lớp không? <br />
                </p>
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal">Hủy</a>
                    <a href="javascript:;" class="btn btn-leaver font-size-17 font-sanpro-semibold"
                        @click="handleLeaver()">Đồng ý</a>
                </div>
            </div>

        </b-modal>

    </div>
</template>

<script>
import { leaverClassSchool } from './../_api/classSchoolServices';
export default {
    name: "ModalLeaveClassSchool",
    props: {
        classSchoolId: {
            type: Number,
            default: 0
        }
    },
    components: {
    },
    // watch: {
    //     classSchoolId(newval) {
    //         console.log(newval)
    //         if (newval > 0) {
    //             this.getDetailClassSchool()
    //         }
    //     }
    // },
    data() {
        return {
            confirmActive: {},
            submitted: false,
            isLoading: false,

        }
    },

    computed: {
        screenWidth() {
            return window.innerWidth;
        },
    },
    mounted() {
        this.handleShowModal()

    },

    methods: {

        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        handleLeaver() {
            let self = this
            leaverClassSchool(this.classSchoolId).then((res) => {
                if (res && res.data && !res.errors) {
                    self.$toast.success('Bạn đã rời khỏi lớp học')
                    self.handleDone()
                }
            })
        },
        resetModal() {

        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-leaver-member-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-leaver-member-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-leaver-member-class-school'].show()
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    background-color: red;
}

.wrap-form-leaver-class-school {
    padding: 20px;
    background-color: white;
    .btn-leaver{
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
        }
        .btn-cancel{
            margin-right: 10px;
        }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>